import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import {ReactComponent as AccessDeniedSvg} from "../../assets/images/accessDenied.svg";

function AccessDenied({hasSubcribe=false}) {
    const navigate = useNavigate();
  return (
    <>
          <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center  h-auto"
      >
    <div className=" bg-white fixed z-10 w-full h-full flex flex-col justify-center items-center mx-auto text-center">
        <div className="w-[50%]">
            <AccessDeniedSvg/>
        </div>
        <h1 className=" text-lg font-medium my-4">Access Denied , {`${hasSubcribe==true?"Subscribe the Standard for the access":"Please contact admin to access this page"}`}</h1>
        <div className=" flex items-center gap-5">
        <NavLink to="/main/standard"><button className=" bg-[#e8505b] px-2 text-white py-1 rounded-md" style={{border:"1px solid #e8505b"}}>Home</button></NavLink> 
        <button onClick={()=>navigate(-1)} className=" px-3 text-[#e8505b] py-1 rounded-md " style={{border:"1px solid #e8505b"}}>Back</button>
            </div>
    </div>
      </div>
</>
  )
}

export default AccessDenied